<gk-status-bar [menuOpen]="menuOpen" (menuOpenEvent)="menuOpen = true">
</gk-status-bar>
<gk-snack-bar></gk-snack-bar>
<div class="content" data-at="page-content">
  <nav class="nav">
    <gk-navigation
      [menuOpen]="menuOpen"
      (menuCloseEvent)="menuOpen = false"
    ></gk-navigation>
  </nav>
  <section class="main-content">
    <router-outlet></router-outlet>
  </section>
  <gk-loading-indicator
    *ngIf="this.isLoading"
    [showOverlay]="this.isLoadingShowOverlay"
  ></gk-loading-indicator>
</div>
